export default __webpack_public_path__ + "static/media/img02.941dc911.jpg";